import React from 'react';
import { ImageLgComponent } from "./image.component";
import { TextLgComponent } from "./text.component";
import "./user-picture.style.scss";
export const UserPictureLG = props => {
  const {
    showOnlyText = false,
    image,
    text
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, !showOnlyText && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImageLgComponent, image)), (!text.disableName || text.subTitle) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextLgComponent, text))));
};